/*
 * Built by CN/D - Connecting The Dots Agency
 * Theme: UnlockBali v1.0
 * Client: Deni Matros
 * https://cn-dots.com
 */
console.log(
  '%cCN/D%c UnlockBali v1.0%c https://cn-dots.com',
  'background:#1f1d19;color:#fff;padding:3px 8px;border-radius:10px;font-weight:700;',
  'color:#1f1d19;font-weight:700;padding:0 6px;',
  'color:#6b665b;'
);

const revealEls = document.querySelectorAll('.reveal');
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.15 });
revealEls.forEach((el) => observer.observe(el));

const sticky = document.getElementById('stickyBar');
const hero = document.getElementById('hero');
let stickyVisible = false;

window.addEventListener('scroll', () => {
  const show = hero.getBoundingClientRect().bottom < 0;
  if (show !== stickyVisible) {
    stickyVisible = show;
    if (show) {
      sticky.style.display = 'flex';
      requestAnimationFrame(() => sticky.classList.add('show'));
    } else {
      sticky.classList.remove('show');
      setTimeout(() => { if (!stickyVisible) sticky.style.display = 'none'; }, 360);
    }
  }
}, { passive: true });

const siteFooter = document.getElementById('site-footer');
let footerObserverPaused = false;
if (siteFooter && sticky) {
  const footerObserver = new IntersectionObserver((entries) => {
    if (footerObserverPaused) return;
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0.05) {
        sticky.classList.add('sticky--hidden');
      } else {
        sticky.classList.remove('sticky--hidden');
      }
    });
  }, { threshold: [0, 0.05, 1] });
  footerObserver.observe(siteFooter);
}

if (sticky) {
  const stickyLink = sticky.querySelector('a[href^="#"]');
  if (stickyLink) {
    stickyLink.addEventListener('click', (event) => {
      const href = stickyLink.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      footerObserverPaused = true;
      const stickyHeight = sticky.offsetHeight || 72;
      const top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeight - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      setTimeout(() => { footerObserverPaused = false; }, 900);
    });
  }
}

document.querySelectorAll('.faq-q').forEach((button) => {
  button.addEventListener('click', () => {
    const answer = button.nextElementSibling;
    const isOpen = answer.classList.contains('open');

    document.querySelectorAll('.faq-a').forEach((a) => a.classList.remove('open'));
    document.querySelectorAll('.faq-q').forEach((q) => {
      q.classList.remove('active');
      q.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      answer.classList.add('open');
      button.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    }
  });
});

const popup = document.getElementById('exitPopup');
const popClose = document.getElementById('popClose');
let popupShown = false;
let popupPreviousFocus = null;
let mobileTriggered = false;

const FOCUSABLE = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';

const trapFocus = (e) => {
  if (e.key !== 'Tab') return;
  const els = Array.from(popup.querySelectorAll(FOCUSABLE)).filter((el) => !el.disabled);
  if (!els.length) return;
  const first = els[0], last = els[els.length - 1];
  if (e.shiftKey) {
    if (document.activeElement === first) { e.preventDefault(); last.focus(); }
  } else {
    if (document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
};

const closePopup = () => {
  popup.classList.remove('show');
  popup.removeEventListener('keydown', trapFocus);
  popupPreviousFocus?.focus();
};

const openPopup = () => {
  if (popupShown) return;
  popupShown = true;
  popup.classList.add('show');
  popupPreviousFocus = document.activeElement;
  const firstFocusable = popup.querySelector(FOCUSABLE);
  if (firstFocusable) firstFocusable.focus();
  popup.addEventListener('keydown', trapFocus);
};

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && popupShown) closePopup();
});

document.addEventListener('mouseout', (event) => {
  if (event.clientY <= 0) openPopup();
});

window.addEventListener('scroll', () => {
  if (popupShown) return;
  const ratio = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
  if (ratio > 0.7) openPopup();
}, { passive: true });

if (window.innerWidth < 768) {
  let mbLast = window.scrollY, mbPeak = window.scrollY;
  let mbHalf = false, mbRevAt = 0, mbRaf = false;
  window.addEventListener('scroll', () => {
    if (mbRaf) return;
    mbRaf = true;
    requestAnimationFrame(() => {
      mbRaf = false;
      if (popupShown || mobileTriggered) return;
      const y = window.scrollY;
      if (y > mbLast) {
        if (y > document.body.scrollHeight * 0.5) mbHalf = true;
        mbPeak = y; mbRevAt = 0;
      } else if (mbHalf) {
        if (!mbRevAt) mbRevAt = Date.now();
        if ((mbPeak - y) > 120 && (Date.now() - mbRevAt) < 500) {
          mobileTriggered = true; openPopup();
        }
      }
      mbLast = y;
    });
  }, { passive: true });
}

popClose.addEventListener('click', () => closePopup());
popup.addEventListener('click', (event) => {
  if (event.target === popup) closePopup();
});

document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('.reveal').forEach((el) => {
    if (!el.classList.contains('is-visible')) {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) el.classList.add('is-visible');
    }
  });
});
